<template>
  <validation-observer
    v-show="isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      id="number-of-other-vehicles"
      :validated="formObserver.validated"
      v-bind="observer"
    >
      <form-row
        label="How many other vehicles are there in the household?"
        :error="formObserver.validated && !observer.valid"
      >
        <template
          v-if="helpText"
          #helpText
        >
          <div
            class="d-flex align-start"
            data-unit-test="help-text"
          >
            <v-icon
              color="primary"
              class="mr-4"
            >
              mdi-credit-card-outline
            </v-icon>
            <div>
              <div
                v-if="helpText.priceSensitive"
                data-unit-test="price-sensitive"
              >
                <strong>Price sensitive question</strong>
                <br>
              </div>
              <div
                id="help-text-value"
                v-html="helpText.value || helpText"
              />
            </div>
          </div>
        </template>
        <validation-provider
          v-slot="{ failed }"
          :vid="`${stepId}_number-of-other-vehicles`"
          :data-unit-test="`${stepId}_number-of-other-vehicles`"
          name="Number of Other Vehicles"
          :rules="{
            required: true,
            is_not: { other: null }
          }"
        >
          <radio
            v-model="numberOfOtherVehiclesGenericModel"
            :name="`${stepId}-number-of-other-vehicles`"
            :data-test="fieldTrackerId.main"
            :items="numberOfOtherVehiclesGenericOptions"
            :error="failed"
            :error-messages="failed ? ['The number of other vehicles field is required.'] : []"
            column
            return-object
          />
        </validation-provider>
      </form-row>
      <form-row
        v-if="numberOfOtherVehicles"
        gap="16"
      >
        <validation-provider
          v-slot="{ errors }"
          :vid="`${stepId}_number-of-other-vehicles`"
          :data-unit-test="`${stepId}_number-of-other-vehicles_other`"
          name="Number of Other Vehicles"
          rules="listOptionRequired"
        >
          <qz-select
            v-model="questionData.numberOfOtherVehicles"
            :data-test="fieldTrackerId.other"
            :items="numberOfOtherVehiclesOtherOptions"
            :error-messages="errors"
            :placeholder="helpers.getPlaceholderResponsiveText('Please select no. of other vehicles', isMobile)"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import {
  omit,
  pick,
  snakeCase,
} from 'lodash';
import QuestionBase from './Base';

export default {
  name: 'question-number-of-other-vehicles',
  extends: QuestionBase,
  data () {
    return {
      fields: ['numberOfOtherVehicles'],
    };
  },
  computed: {
    numberOfOtherVehicles () {
      return this.numberOfOtherVehiclesGenericModel !== null &&
        !this.constants.COVER_NUMBER_OF_OTHER_VEHICLES_FAVORITES.includes(this.numberOfOtherVehiclesGenericModel);
    },
    numberOfOtherVehiclesGenericOptions () {
      return [
        ...this.helpers.createOptions({
          source: pick(this.constants.COVER_NUMBER_OF_OTHER_VEHICLES, this.constants.COVER_NUMBER_OF_OTHER_VEHICLES_FAVORITES),
          asNumbers: true,
        }),
        {
          ...this.constants.OTHER_OPTIONS,
        },
      ];
    },
    numberOfOtherVehiclesOtherOptions () {
      return this.helpers.createOptions({
        source: omit(this.constants.COVER_NUMBER_OF_OTHER_VEHICLES, this.constants.COVER_NUMBER_OF_OTHER_VEHICLES_FAVORITES),
        asNumbers: true,
      });
    },
    numberOfOtherVehiclesGenericModel: {
      get () {
        if (this.questionData.numberOfOtherVehicles === null) return null;
        return this.constants.COVER_NUMBER_OF_OTHER_VEHICLES_FAVORITES.includes(this.stepData.numberOfOtherVehicles) ? this.stepData.numberOfOtherVehicles : true;
      },
      set (val) {
        this.questionData.numberOfOtherVehicles = val.logical ? val.logicalValue : val.value;
      },
    },
    fieldTrackerId () {
      return {
        main: snakeCase(this.questionFields.numberOfOtherVehicles),
        other: `${snakeCase(this.questionFields.numberOfOtherVehicles)}_other`,
      };
    },
  },
};
</script>
